import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import Navbar2 from '../../components/Navbar2/Navbar2'
import PageTitle from '../../components/pagetitle/PageTitle'
import UseCases from '../../components/csp/UseCases'
import IntegrationSteps from '../../components/csp/IntegrationSteps'
import WalkthroughCta from '../../components/csp/WalkthroughCta'
import Footer from '../../components/footer/Footer'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { meetingNote, partnerBenefits } from '../../content/csp'

const ClickHandler = () => {
  window.scrollTo(10, 0)
}

const PartnersPage = () => {
  return (
    <Fragment>
      <Navbar2 />
      <PageTitle pageTitle={'Partners'} pagesub={'Partners'} />
      <section className="csp-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <span className="csp-kicker">Partnership</span>
              <h2 className="csp-title">
                Use CSPNow with your members. Do not build the same tools
                twice.
              </h2>
              <p className="csp-lead">
                Common Sense Politics is looking for organizations that already
                work with political moderates. A partner gets a Circle, access
                to the wider user base, and a way to put polls and topics in
                front of people without standing up a separate platform.
              </p>
            </div>
          </div>
          <div className="csp-grid csp-grid--2" style={{ marginTop: 40 }}>
            {partnerBenefits.map((benefit) => (
              <article className="csp-card csp-card--ruled" key={benefit.title}>
                <h3>{benefit.title}</h3>
                <p>{benefit.text}</p>
              </article>
            ))}
          </div>
          <div className="csp-note">
            <h3>{meetingNote.title}</h3>
            <p>{meetingNote.text}</p>
          </div>
          <Link onClick={ClickHandler} className="csp-more" to="/how-it-works">
            See how your Circle would work
          </Link>
        </div>
      </section>
      <UseCases />
      <IntegrationSteps />
      <WalkthroughCta />
      <Footer />
      <Scrollbar />
    </Fragment>
  )
}

export default PartnersPage
